import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init({
	once: true
});


// NAVBAR TOGGLE RESPONSIVE
const toggler = document.querySelector('.navbar-toggler');
const collapse = document.querySelector('.navbar-collapse');
const close = document.querySelector('.navbar-collapse .close');
toggler.addEventListener("click", function(){
    collapse.classList.toggle('show'); 
    // document.querySelector('body').classList.toggle('hidden');
})
close.addEventListener("click", function(){
    collapse.classList.remove('show'); 
})